import { Play } from "lucide-react";
import { useI18n } from "@/lib/i18n";

// Kavi spokesperson video — generated 2026-07-01 via fal.ai sadtalker + ElevenLabs Rachel
const VIDEO_SRC = "https://yyoqtmbihanzxzeduimj.supabase.co/storage/v1/object/public/showcase/kavi-spokesperson-video.mp4";

export function SeeInAction() {
  const { t } = useI18n();
  return (
    <section className="py-20 px-6 relative" style={{ backgroundColor: "#04091a" }}>
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-4 tracking-tight">
          {t("seeinaction.title")} <span className="text-gradient-orange">{t("seeinaction.titleHighlight")}</span>
        </h2>
        <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto mb-10">
          {t("seeinaction.desc")}
        </p>

        <div className="relative aspect-video rounded-2xl border border-border bg-card overflow-hidden shadow-2xl">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-primary/5" />
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
            {VIDEO_SRC ? (
              <>
                <button
                  type="button"
                  aria-label={t("seeinaction.playAria")}
                  className="relative h-20 w-20 md:h-24 md:w-24 rounded-full bg-gradient-to-br from-primary to-primary-glow flex items-center justify-center shadow-[0_0_60px_-10px_hsl(var(--primary))] hover:scale-110 transition-transform"
                >
                  <span className="absolute inset-0 rounded-full bg-primary/40 animate-ping" />
                  <Play className="relative h-8 w-8 md:h-10 md:w-10 text-primary-foreground fill-current ml-1" />
                </button>
                <span className="text-sm text-muted-foreground">{t("seeinaction.watchDemo")}</span>
              </>
            ) : (
              <>
                <div className="h-16 w-16 rounded-full bg-card border border-border/60 flex items-center justify-center">
                  <Play className="h-7 w-7 text-muted-foreground/30 fill-current ml-0.5" />
                </div>
                <p className="text-sm text-muted-foreground">{t("seeinaction.comingSoon")}</p>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
